import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["media", "smallMedia", "thresholdBreakpoint", "matchSmallMediaByDefault"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import { Device } from "../../constants/device";
import { useMemo } from 'react';
import useMediaWithDevice from "../../hooks/use-media-with-device";
import { StyledModuleMediaContainer } from "./module-media-container.styles";
import { defaultProps } from "./constants";
import { jsx as _jsx } from "react/jsx-runtime";
var ModuleMediaContainer = function ModuleMediaContainer(_ref) {
  var bigMedia = _ref.media,
    smallMedia = _ref.smallMedia,
    _ref$thresholdBreakpo = _ref.thresholdBreakpoint,
    thresholdBreakpoint = _ref$thresholdBreakpo === void 0 ? defaultProps.thresholdBreakpoint : _ref$thresholdBreakpo,
    matchSmallMediaByDefault = _ref.matchSmallMediaByDefault,
    passThroughProps = _objectWithoutProperties(_ref, _excluded);
  var isSmallScreen = useMediaWithDevice("(max-width: ".concat(thresholdBreakpoint - 1, "px)"), Device.Mobile, matchSmallMediaByDefault);
  var media = useMemo(function () {
    if (smallMedia && isSmallScreen) {
      return smallMedia;
    }
    return bigMedia;
  }, [bigMedia, smallMedia, isSmallScreen]);
  return /*#__PURE__*/_jsx(StyledModuleMediaContainer, _objectSpread(_objectSpread({}, passThroughProps), {}, {
    children: media
  }));
};
ModuleMediaContainer.defaultProps = defaultProps;
export default ModuleMediaContainer;